import { PRODUCT_CATEGORY } from './product';

export const SLIDE_BANNER_GLOBAL = [
  {
    bgImage: '/assets/images/banners/slide/img-main-banner-bg-1.png',
    contentsImage: {
      ko: '/assets/images/banners/slide/global/img-main-banner-txt-1@2x.png', // 1개월 $6.9
      en: '/assets/images/banners/slide/global/img-main-banner-txt-3@2x.png', // monthly $6.9
    },
    link: '/product/purchase/6',
  },
  {
    bgImage: '/assets/images/banners/slide/img-main-banner-bg-2.png',
    contentsImage: {
      ko: '/assets/images/banners/slide/global/img-main-banner-txt-2@2x.png', // 1년, $39.9
      en: '/assets/images/banners/slide/global/img-main-banner-txt-4@2x.png', // annual $39.9
    },
    link: '/product/purchase/7',
  },
];

// 비로그인: i18n.languages[0] === 'ko'
// 로그인: userInfo.country === PRODUCT_REGION.KR
export const SLIDE_BANNER_KR = [
  {
    bgImage: '/assets/images/banners/slide/img-main-banner-bg-1.png',
    contentsImage: {
      ko: '/assets/images/banners/slide/kr/img-main-banner-txt-1@2x.png', // 1개월 4400원
      en: '/assets/images/banners/slide/kr/img-main-banner-txt-3@2x.png', // monthly ₩4400
    },
    link: '/product/purchase/5',
  },
  {
    bgImage: '/assets/images/banners/slide/img-main-banner-bg-3.png',
    contentsImage: {
      ko: '/assets/images/banners/slide/kr/img-main-banner-txt-2@2x.png', // 1개월 3300원
      en: '/assets/images/banners/slide/kr/img-main-banner-txt-4@2x.png', // monthly ₩3300
    },
    link: '/product/purchase/9',
  },
];

export const HOME_BANNER_GLOBAL = {
  [PRODUCT_CATEGORY.KARAOKE]: {
    icon: '/assets/images/banners/home/common-img-img-banner-karaoke-icon.svg',
    bgImage: '/assets/images/banners/home/common-img-img-banner-karaoke-bg.png',
    bgColor: '#6351be',
    link: '/product/purchase?tab=K-ARAOKE',
  },
};

export const HOME_BANNER_KR = {
  [PRODUCT_CATEGORY.KARAOKE]: {
    icon: '/assets/images/banners/home/common-img-img-banner-karaoke-icon.svg',
    bgImage: '/assets/images/banners/home/common-img-img-banner-karaoke-bg.png',
    bgColor: '#6351be',
    link: '/product/purchase?tab=K-ARAOKE',
  },
  [PRODUCT_CATEGORY.BIXBY]: {
    icon: '/assets/images/banners/home/common-img-img-banner-bixby-icon.svg',
    bgImage: '/assets/images/banners/home/common-img-img-banner-bixby-bg.png',
    bgColor: '#1ab0ad',
    link: '/product/purchase?tab=BIXBY',
  },
};
